import { useState, useEffect } from "react";
import appLogo from "/applogo.svg";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`ww-max-w-7xl ww-mx-auto ww-rounded-lg md:ww-rounded-full ${isScrolled ? "ww-top-0 md:ww-top-4" : "ww-top-4"} ww-fixed ww-left-0 ww-right-0 ww-z-50 ww-transition-all ww-duration-300 ${
        isScrolled
          ? "ww-bg-white ww-backdrop-blur-xl ww-shadow-lg"
          : "ww-bg-white/50 ww-backdrop-blur-sm"
      }`}
    >
      <div className="ww-container ww-mx-auto ww-px-4 sm:ww-px-8">
        <div className="ww-flex ww-items-center ww-justify-start ww-h-20">
          <div className="ww-flex-shrink-0">
            <a href="/" className="ww-cursor-pointer ww-block">
              <img
                src={appLogo}
                width={59}
                height={43}
                alt="Withinehr Logo"
                className="ww-block"
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
